import { useParams } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { useGetEmrsQuery, useGetProjectQuery } from '~/api/v2/hooks';
import { EmrClusterBlock, EmrStudioBlock } from './components';
import { studioIntegrationHeaderStyles } from './styles';

const StudioIntegrationTab = () => {
  const projectId = +useParams().projectid!;
  const { data: emrs } = useGetEmrsQuery({ projectId });
  const { data: project } = useGetProjectQuery({ projectId });

  return (
    <Box minHeight="50vh">
      <Box p={4} gap={4} display="flex" flexDirection="column">
        <Box sx={studioIntegrationHeaderStyles}>
          <Typography variant="h5">Studio Integration</Typography>
        </Box>
        {project && <EmrStudioBlock />}
        {project && !!emrs && <EmrClusterBlock />}
      </Box>
    </Box>
  );
};

export default StudioIntegrationTab;
